<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Loading from "@/components/c-loading";
import List from "../../../components/list";
import { commissionService } from "../../../services/saleservice/commission.service";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Commission Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    List
  },
  watch: {
      valuePaidAmount: function(newVal) { 
        this.changeBalance(newVal);
      }
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Commission",
      breadCrumb: {},
      commissionData: null,
      commissionPaymentData: {},
      valueCode: '',
      valueName: '',
      valueSale: '',
      valueSeller: '',
      valueProperty: '',
      valueCommission: 0,
      valuePaid: 0,
      valueDate: this.$moment().clone().format('YYYY-MM-DD'),
      valuePaidAmount: 0,
      valueBalance: 0,
      valueMax: 0,

    };
  },
  mounted() {
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 

  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      commissionService.log(id)
        .then(response => {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

          this.fetchingStats = true;
          this.commissionData = response;

          this.valueCode = this.commissionData.data.code;
          this.valueName = this.commissionData.data.name;
          this.valueSale = this.commissionData.data.sale;
          this.valueSeller = `${this.commissionData.data.seller} (${this.commissionData.data.seller_en})`;
          this.valueProperty = this.commissionData.data.property;
          this.valueCommission = this.formatCurrency(this.commissionData.data.total_commission);
          this.valuePaid = this.formatCurrency(this.commissionData.data.commission_paid);
          this.valueBalance = Math.round((this.valueCommission - this.valuePaid) * 100) / 100;
          this.valueMax = Math.round((this.valueCommission - this.valuePaid) * 100) / 100;
          
          this.commissionPaymentData = {data: this.commissionData.data.commission_payments};

          console.log(this.commissionPaymentData);
          
          // (Math.round() * 100 / 100); //this.commissionData.data.principle_paid; //  this.formatCurrency(this.commissionData.data.principle_paid); 

          // console.log(JSON.stringify(this.commissionData.data.principle_paid));
        });
    },
    

    submitCancel: function() {

      // console.log(this.dataType);

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "commission-list"
          });

        }
      });
      
    },
    submitSave: function() {

      this.tryingToSubmit = true;

      if(parseFloat(this.valuePaidAmount) > parseFloat(this.valueMax)) {
        this.$swal.fire({
          title: i18n.t('commission.message.title'),
          text: i18n.t('commission.message.text'),
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.cancel-confirm.yes')
        });
        
        return;
      }

      let commission = {
        commission_id: this.$route.params.id,
        paid_date: this.valueDate,
        paid: this.valuePaidAmount,
      };

      // console.log(JSON.stringify(commission));


      commissionService.pay(commission)
        .then(response => {
          this.tryingToSubmit = false;
          if(response.status == 200) {
            this.clearForm();
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "commission-list"
                });
              } 
            });
          }
        
      });
      
    },

    clearForm: function() {
      
      this.valueCode = '';
      this.valueName = '';
      this.valueSale = '';
      this.valueSeller = '';
      this.valueProperty = '';
      this.valueCommission = 0;
      this.valuePaid = 0;
      this.valuePaidAmount = 0;
      this.valueBalance = 0;
      this.valueMax = 0;
      this.valueDate = this.$moment().clone().format('YYYY-MM-DD');
      
    }, 

    formatCurrency(value, sign = '', decimal = '.00') {
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

    },

    changeBalance: function(paid) {
      this.valueBalance = Math.round((this.valueCommission - this.valuePaid - paid) * 100) / 100;
    }

  }
};
</script>

<template>
  <Layout>
    <PageHeader :items="[{
      text: $t('commission.list'),
      href: '/additional/commission',
    }, {
      text: $t('commission.paid'),
      active: true
    }]" :title="$t('commission.paid')" />
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <List v-bind:dataList="commissionPaymentData" 
                    v-bind:showNo="false"
                    v-bind:updating="fetchingStats" 
                    v-bind:navigate="pageNavigate"
                    v-bind:formats="[{name: 'paid_date', type: 'date'}, {name: 'paid', type: 'currency', sign: '$'}, {name: 'balance', type: 'currency', sign: '$'}]"
                        v-bind:fields="[ `paid_date: ${$t('commission.date')}`, 
                          `paid: ${$t('commission.paid')}`, 
                          `balance: ${$t('commission.commission-remain')}`, 
                          `pay_by: ${$t('commission.pay-by')}`
                        ]" 
                        v-bind:filter="{}"
                    
                />  
              </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="valueCode"
                    :label="'commission.code'"
                     /> 
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'date'"
                    :id="'sale_date'"
                    :disabled="true"
                    v-model="valueDate"
                    :label="'general.date'" 
                     /> 
                </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'property_id'"
                    :disabled="true"
                    v-model="valueProperty"
                    :label="'property.text'"
                     /> 
              </div>
              <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'seller_id'"
                    :disabled="true"
                    v-model="valueSeller"
                    :label="'seller.text'"
                     /> 
                </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <Input 
                  :type="'number'"
                  :id="'commission'"
                  :disabled="true"
                  v-model="valueCommission"
                  :label="'commission.commission-amount'"
                  :last="'USD'"
                    /> 
              </div>
              <div class="col-md-6">
                <Input 
                  :type="'number'"
                  :id="'name'"
                  :disabled="true"
                  v-model="valuePaid"
                  :label="'commission.commission-paid'"
                  :last="'USD'"
                    /> 
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">

                <div inline class="row gy-2 gx-3 align-items-end">
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-x-circle'" 
                      v-bind:buttonType="'button'"
                      v-bind:variant="'danger'"
                      @click="submitCancel()"
                      v-bind:title="$t('general.cancel')"  />
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form> 
  
  </Layout>
</template>